import type { ReactNode } from 'react';

import FormatDateTime from 'components/common/FormatDateTime';
import { ViewPlaceholder } from './ViewPlaceholder';

export interface ViewDateTimeProps {
  readonly value: string | null | undefined;
  readonly placeholder?: ReactNode;
}

/** A timestamp, in the user's chosen format and timezone (see FormatDateTime). */
export const ViewDateTime = ({ value, placeholder }: ViewDateTimeProps) =>
  value === null || value === undefined || value === '' ? <ViewPlaceholder placeholder={placeholder} /> : <FormatDateTime value={value} />;
